import { render, staticRenderFns } from "./part-one.vue?vue&type=template&id=0fd0894c&scoped=true"
import script from "./part-one.vue?vue&type=script&lang=js"
export * from "./part-one.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd0894c",
  null
  
)

export default component.exports